import { EuiLoadingContent, EuiFieldSearch, EuiButtonIcon } from '@elastic/eui';
import {
  LoadScriptNext,
  Autocomplete,
  Marker,
  InfoWindow,
  GoogleMap,
} from '@react-google-maps/api';
import React, { useEffect, useState } from 'react';
// import { LanguageContext } from "../../../i18n"
import { INCO2Address } from '../../../types';
import { parseGooglePlace, getCorrelation } from '../../../utils/helpers';
//@ts-ignore
import LogEngine from '@eait/logengine-client';

const libraries: any = ['places'];
const fields = ['geometry', 'formatted_address', 'address_components'];
//@ts-ignore
const googleMapsApiKey = window.Configs.GOOGLE_MAPS_API_KEY;
const MAX_ZOOM = 16;
const MIN_ZOOM = 14;

interface IProps {
  address?: INCO2Address;
  setAddress: React.Dispatch<INCO2Address>;
}
export const GoogleMapFull: React.FC<IProps> = ({ address, setAddress }) => {
  // const { translate } = useContext(LanguageContext)
  //console.log(address);
  //console.log(setAddress);

  const [autocomplete, setAutocomplete] = useState<any>();

  const [geocoder, setGeocoder] = useState<any>();
  //@ts-ignore
  const handleOnLoad = () => setGeocoder(new google.maps.Geocoder());

  const hasGeocoder = !!geocoder;
  const effectCenterMap = () => {
    if (hasGeocoder && 'geolocation' in navigator)
      navigator.geolocation.getCurrentPosition((position) =>
        fireGeocode(
          geocoder,
          position.coords.latitude,
          position.coords.longitude,
          setAddress
        )
      );
  };
  //eslint-disable-next-line
  useEffect(effectCenterMap, [hasGeocoder]);

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      const newPosition = place?.geometry?.location;
      if (newPosition) {
        setAddress(parseGooglePlace(place));
      }
      //console.log(parseGooglePlace(place));
    }
  };

  const handleOnMapClick = (point: any) => {
    if (point && hasGeocoder) {
      const lat = point.latLng.lat();
      const lng = point.latLng.lng();
      fireGeocode(geocoder, lat, lng, setAddress);
    }
  };

  // se viene cambiato manualmente
  const onMarkerChanged = (place: MouseEvent) => {
    //setAddress(parseGooglePlace(place));
    console.log('OnMarkerChange');
    console.log(place);
  };
  //onDragEnd={(event) => { console.log(event.latLng) }}

  const [marker, setMarker] = useState();
  const handleOnMarkerLoad = (marker: any) => setMarker(marker);

  const [isOpenWindow, setIsOpenWindow] = useState(true);
  const handleOnClickMarker = () => setIsOpenWindow(true);
  const handleOnClose = () => setIsOpenWindow(false);

  const [labelAddr, setLabelAddr] = useState('');
  const [isWriting, setIsWriting] = useState(false);
  const handleChangeFocus = () => {
    setIsWriting((value) => !value);
    setLabelAddr('');
  };
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    isWriting && setLabelAddr(e.target.value);

  //GESTIONE DEL BLOCCO DELLA MAPPA
  //FIX BLOCCO MAPPA FORZATO
  //if (window.Configs.UNBLOCKMAPS)
  const bloccomaps = false;
  //@ts-ignore
  if (bloccomaps) {
    return (
      <LoadScriptNext
        googleMapsApiKey={googleMapsApiKey}
        libraries={libraries}
        loadingElement={<EuiLoadingContent />}
      >
        <GoogleMap
          //@ts-ignore
          mapContainerClassName='eui-fullWidth'
          mapContainerStyle={{ height: '55vh', width: '100%' }}
          zoom={address?.formattedAddress ? MAX_ZOOM : MIN_ZOOM}
          center={
            address?.latitude &&
            address.longitude && {
              lat: address.latitude,
              lng: address.longitude,
            }
          }
          options={{
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            gestureHandling: 'none',
          }}
          //Gestione del click della mappa

          onClick={handleOnMapClick}
          onLoad={handleOnLoad}
        >
          <Autocomplete
            onLoad={setAutocomplete}
            onPlaceChanged={onPlaceChanged}
            fields={fields}
          >
            <EuiFieldSearch
              isClearable={false}
              value={isWriting ? labelAddr : address?.formattedAddress ?? ''}
              onChange={handleOnChange}
              onFocus={handleChangeFocus}
              onBlur={handleChangeFocus}
              // placeholder={translate("common.map.placeholder")}
              fullWidth
              append={[
                <label className='euiFormLabel euiFormControlLayout__append eui-hideFor--xs eui-hideFor--s eui-hideFor--m z-index-100'>
                  {/* {translate("step3.map.localize")} */}
                </label>,
                <EuiButtonIcon
                  aria-label='Localize'
                  iconType='visMapCoordinate'
                  onClick={effectCenterMap}
                  className='z-index-100'
                />,
              ]}
            />
          </Autocomplete>
          <Marker
            position={
              address?.latitude &&
              address.longitude && {
                lat: address.latitude,
                lng: address.longitude,
              }
            }
            animation='DROP'
            // draggable={true}
            onDragEnd={(event) => {
              onMarkerChanged(event);
            }}
            onLoad={handleOnMarkerLoad}
            onClick={handleOnClickMarker}
          />
          //In caso non si voglia avere indicazioni dei poi sulla mappa
          disattivo //qui.
          {/* {marker && address?.formattedAddress && isOpenWindow && (
            <InfoWindow anchor={marker} onCloseClick={handleOnClose}>
              <p>{address.formattedAddress}</p>
            </InfoWindow>
          )} */}
        </GoogleMap>
      </LoadScriptNext>
    );
  } else {
    return (
      <LoadScriptNext
        googleMapsApiKey={googleMapsApiKey}
        libraries={libraries}
        loadingElement={<EuiLoadingContent />}
      >
        <GoogleMap
          //@ts-ignore
          mapContainerClassName='eui-fullWidth'
          mapContainerStyle={{ height: '55vh', width: '100%' }}
          zoom={address?.formattedAddress ? MAX_ZOOM : MIN_ZOOM}
          center={
            address?.latitude &&
            address.longitude && {
              lat: address.latitude,
              lng: address.longitude,
            }
          }
          options={{
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            gestureHandling: 'none',
          }}
          //Gestione del click della mappa
          //onClick={handleOnMapClick}
          onLoad={handleOnLoad}
        >
          <Autocomplete
            onLoad={setAutocomplete}
            onPlaceChanged={onPlaceChanged}
            fields={fields}
          >
            <EuiFieldSearch
              isClearable={false}
              value={isWriting ? labelAddr : address?.formattedAddress ?? ''}
              onChange={handleOnChange}
              onFocus={handleChangeFocus}
              onBlur={handleChangeFocus}
              // placeholder={translate("common.map.placeholder")}
              fullWidth
              append={[
                <label className='euiFormLabel euiFormControlLayout__append eui-hideFor--xs eui-hideFor--s eui-hideFor--m z-index-100'>
                  {/* {translate("step3.map.localize")} */}
                </label>,
                <EuiButtonIcon
                  aria-label='Localize'
                  iconType='visMapCoordinate'
                  onClick={effectCenterMap}
                  className='z-index-100'
                />,
              ]}
            />
          </Autocomplete>
          <Marker
            position={
              address?.latitude &&
              address.longitude && {
                lat: address.latitude,
                lng: address.longitude,
              }
            }
            animation='DROP'
            // draggable={true}
            onDragEnd={(event) => {
              onMarkerChanged(event);
            }}
            onLoad={handleOnMarkerLoad}
            onClick={handleOnClickMarker}
          />
          //In caso non si voglia avere indicazioni dei poi sulla mappa
          disattivo //qui.
          {marker && address?.formattedAddress && isOpenWindow && (
            <InfoWindow anchor={marker} onCloseClick={handleOnClose}>
              <p>{address.formattedAddress}</p>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScriptNext>
    );
  }
};

const fireGeocode = (
  geocoder: any,
  lat: any,
  lng: any,
  setAddress: React.Dispatch<INCO2Address>
) => {
  geocoder.geocode(
    { location: { lat, lng } },
    (results: any[], status: string) => {
      if (status === 'OK' && results && results[0]) {
        setAddress(parseGooglePlace(results[0]));
      } else {
        console.error(results, status);
        LogEngine.SendLog(
          LogEngine.LogLevels.ERROR,
          'Google geocode service failed',
          getCorrelation(),
          { results, status }
        );
      }
    }
  );
};
